const E = {
  BUSY: "busy",
  AWAY: "away",
  OFFLINE: "offline",
  ACTIVE: "active"
}, S = [
  E.BUSY,
  E.AWAY,
  E.OFFLINE,
  E.ACTIVE
];
export {
  E as PRESENCE_STATES,
  S as PRESENCE_STATES_LIST
};
//# sourceMappingURL=presence-constants.js.map
